<template>
  <div class="companies-page">
    <div :class="loading ? 'hidden' : ''">
      <filter-results
        :refresh="key"
        @fetchDataComplete="fetchDataComplete"
      ></filter-results>
    </div>

    <company-create
      @save="create"
      @cancel="setIsOpen(false)"
      :isOpen="open"
      :company="company"
    />

    <div class="companies-page-loader" :class="loading ? '' : 'hidden'">
      <loading></loading>
    </div>
  </div>
</template>

<script>
import Ui from "@/classes/Ui";
import Modal from "@/components/helpers/Layout/NewModal.vue";
import CompanyCreate from "@/components/pages/companies/CompanyEdit.vue";
import CompanyApi from "@/api/Company";
import Loading from "@/components/helpers/Specific/Loading.vue";
import FilterResults from "@/components/helpers/DataDisplay/FilterResults/Companies";

export default {
  components: { FilterResults, Loading, Modal, CompanyCreate },
  data() {
    return {
      key: 0,
      open: false,
      loading: false,
      modalTitleEdit: "Create Company",
      company: {
        name: "",
        company_website: "",
        address: {
          street: "",
          street_number: "",
          city: "",
          zip: "",
          country: ""
        }
      }
    };
  },
  beforeMount() {
    this.loading = true;
  },
  mounted() {
    Ui.setPageLevel("2");
    Ui.setSecondaryHeaderTabs({});
    Ui.setTitle({ label: "ui.pages.companies" });
    this.setHeaderButtons();
  },
  methods: {
    setHeaderButtons() {
      Ui.setHeaderButtons([
        {
          name: "createcompany",
          action: "companies.create",
          classes: "btn-primary",
          function: this.setOpen
        }
      ])
    },
    setIsOpen(bool) {
      this.open = bool;
      if (!bool && !this.currentPlanIsTalent) {
        this.view = null;
      }
    },
    setOpen() {
      this.open = true;
      this.key++;
    },
    async create(payload) {
      let api = new CompanyApi();
      if (payload) {
        await api.createCompany(payload);
        this.setIsOpen(false);
        this.key++;
      }
    },
    fetchDataComplete() {
      this.loading = false;
    }
  }
};
</script>

<style lang="sass" scoped>
.companies-page
  .companies-page-loader
    z-index: 200
    position: absolute
    top: 0
    left: 0
    margin: 0 auto
    width: 100%
    height: 100%
  .hidden
    visibility: hidden
</style>



// WEBPACK FOOTER //
// Companies.vue?240bd3b3